import React from 'react';
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";
import { FormInputCheckbox } from "../../../ReactHookForm/FormComponents";

import DropdownTransitions from "root/ReactHookForm/ui/DropdownTransitions";

const HookSubFormTransition = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const isTransitioning = watch(sectionName + '.is_transitioning')

    const validateTransitionType = (val) =>
    {
        if (val === null)
        {
            return "Please Select a transition type.";
        }
    }

    return (
        <FieldsetContainer title='Transition' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputCheckbox readOnly={readOnly} label='Is the pupil transitioning this year?' sectionName={sectionName} name={'is_transitioning'} register={register}/>
                </BootstrapCol>
            </BootstrapRow>

            <BootstrapRow>
                {isTransitioning === true && <BootstrapCol width={12}>
                    <label className='col-form-label'>Select the Transition Type</label>
                    <DropdownTransitions name={sectionName + '.transition_id'} control={control} rules={{validate: validateTransitionType}}
                                       placeHolder='Select a Transition type' readOnly={readOnly}/>
                    {formErrors[sectionName]?.transition_id?.type === 'validate' && <ErrorDiv>Please select a transition type</ErrorDiv>}
                </BootstrapCol>}
                {isTransitioning === false && <BootstrapCol width={12}> </BootstrapCol>}
            </BootstrapRow>
        </FieldsetContainer>
    )
}
export default HookSubFormTransition;
